import Logger from "../Logger";
import Page from "../models/Page";

const logger = new Logger();

export default class BackgroundImmageHandler {
  public get className(): string {
    return "BackgroundImmageHandler";
  }
  /**
   * This function in TypeScript React handles the process of downloading an image or PDF file,
   * converting it to a data URL, and setting it as a background using the provided functions.
   * @param e - The `e` parameter in the `downloadImage` function is a React ChangeEvent that represents
   * the event that occurred when a file input element's value changes. It is typically used to access
   * the selected file for further processing.
   * @param {Page} page - The `page` parameter in the `downloadImage` function seems to represent some
   * sort of page object or data structure. It likely contains information about the page size, PDF
   * file, and rotation among other properties. It is used to retrieve specific properties like
   * `pdfFile`, `pagesize`, and `pdf
   * @param setBackgroundFunction - The `setBackgroundFunction` parameter is a function that takes a
   * string parameter and is used to set the background of a page or element with the provided string
   * value.
   */
  downloadImage(e: React.ChangeEvent<HTMLInputElement>, page: Page, setBackgroundFunction: (params: string) => void) {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];

      if (file.type == "application/pdf") {
        const reader = new FileReader();
        reader.readAsBinaryString(file);
        reader.onloadend = function () {
          var data = reader.result;
          const pdfFile = page.pdfFile;
          pdfFile.pdfData = data;
          // a4 300 dpi == 2480 x 3508

          const dpmm = 30;
          pdfFile
            .convertPdfToDataUrl({
              pageNumber: 1,
              targetWidth: page.pagesize.width * dpmm,
              targetHeight: page.pagesize.height * dpmm,
              rotation: page.pdfRotation || 0,
            })
            .then((imgUrl) => {
              // page.resizeImageAfterLoad(imgUrl).then((result) => {
              //   setBackgroundFunction(result as string);
              // });
              setBackgroundFunction(imgUrl);
            });
        };
      } else {
        const reader = new FileReader();
        // reader.readAsDataURL(file);
        reader.onloadend = () => {
          // convert image file to base64 string
          var base64data = reader.result;
          if (typeof base64data == "string") {
            page.resizeImageAfterLoad(base64data).then((result) => {
              setBackgroundFunction(result as string);
            });
          }
        };

        if (file) {
          reader.readAsDataURL(file);
        }
      }
    }
  }
}
